import {Directive, TemplateRef, Input} from '@angular/core'

interface ItemTest {
  (item: any): boolean
}

@Directive({
  selector: '[list-item-expand]',
  standalone: false,
})
export class FilterListItemExpandDirective {
  private _expandable: ItemTest = (item) => {
    return true
  }
  @Input('list-item-expandExpandable')
  set expandable(fn: ItemTest) {
    this._expandable = fn
  }
  get expandable(): ItemTest {
    return this._expandable
  }

  constructor(private tpl: TemplateRef<any>) {}
}
